const faqs = (role, extras = []) => [
  {
    q: `Is there a ${role} internship in Satara?`,
    a: `Yes. Growmore IT Services offers a paid ${role} internship in Satara with weekly live tasks, an offer letter after payment and a completion letter after the last task is approved.`
  },
  {
    q: `Who can apply for this internship?`,
    a: `College students and recent graduates from Satara, Maharashtra and across India can apply. You need a laptop, internet and the basics listed on this page.`
  },
  {
    q: `Is this a paid internship with official letters?`,
    a: `Yes. Plans start from a 1-month track. You receive an official offer letter after payment and a QR-verified completion letter when the last weekly task is approved.`
  },
  ...extras
];

export const internshipSeo = {
  'full-stack-developer': {
    headline: 'Full Stack Developer Internship in Satara',
    seoTitle: 'Full Stack Developer Internship in Satara | Growmore IT Services',
    seoDescription:
      'Full stack developer internship in Satara with React, APIs and databases on live projects. Paid internship with offer and completion letters.',
    seoKeywords:
      'Full Stack Developer Internship in Satara, Full Stack Internship Satara, MERN Internship Satara, React Node.js Internship, Paid Internship Satara, Software Internship Maharashtra, Growmore IT Services',
    faqs: faqs('full stack developer', [
      {
        q: 'What will I build in the full stack internship?',
        a: 'Weekly briefs cover React screens, Laravel or Node APIs, MySQL tables, login flows and a deploy-ready folder — not a dummy certificate project.'
      }
    ])
  },
  'frontend-developer': {
    headline: 'Frontend Developer Internship in Satara',
    seoTitle: 'Frontend Developer Internship in Satara | React | Growmore',
    seoDescription:
      'Frontend developer internship in Satara for React, Tailwind and responsive UI. Paid internship with weekly tasks and official letters.',
    seoKeywords:
      'Frontend Developer Internship in Satara, React Internship Satara, UI Developer Internship, Frontend Internship Maharashtra, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('frontend developer', [
      {
        q: 'Is this a React internship in Satara?',
        a: 'Yes. The frontend developer internship in Satara focuses on React components, responsive Tailwind UI, accessibility and SEO-ready markup.'
      }
    ])
  },
  'backend-developer': {
    headline: 'Backend Developer Internship in Satara',
    seoTitle: 'Backend Developer Internship in Satara | API | Growmore',
    seoDescription:
      'Backend developer internship in Satara for REST APIs, databases and auth. Paid Laravel / API internship with official letters.',
    seoKeywords:
      'Backend Developer Internship in Satara, API Internship Satara, Laravel Internship Satara, PHP Backend Internship, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('backend developer', [
      {
        q: 'Do you offer a Laravel or API internship in Satara?',
        a: 'Yes. The backend developer internship covers REST APIs, validation, databases and file uploads on live Growmore work.'
      }
    ])
  },
  'website-developer': {
    headline: 'Website Development Internship in Satara',
    seoTitle: 'Website Development Internship in Satara | Growmore IT Services',
    seoDescription:
      'Website development internship in Satara for SEO-ready business websites. Paid web internship with weekly tasks and official letters.',
    seoKeywords:
      'Website Development Internship in Satara, Web Development Internship Satara, Website Developer Intern Satara, WordPress Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('website developer', [
      {
        q: 'Will I work on real business websites?',
        a: 'Yes. Weekly tasks cover pages, forms, mobile layout and on-page SEO for business website structure used by local clients.'
      }
    ])
  },
  'software-developer': {
    headline: 'Software Developer Internship in Satara',
    seoTitle: 'Software Developer Internship in Satara | Growmore IT Services',
    seoDescription:
      'Software developer internship in Satara for custom software modules, dashboards and ERP-style workflows. Paid internship with official letters.',
    seoKeywords:
      'Software Developer Internship in Satara, Software Internship Satara, Custom Software Internship, ERP Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('software developer', [
      {
        q: 'Is this a software or ERP internship?',
        a: 'The software developer internship in Satara covers custom software modules, CRUD workflows, roles and simple reports — small ERP-style pieces each week.'
      }
    ])
  },
  'java-developer': {
    headline: 'Java Developer Internship in Satara',
    seoTitle: 'Java Developer Internship in Satara | Core Java | Growmore',
    seoDescription:
      'Java developer internship in Satara for core Java, OOP and simple REST. Paid Java internship with weekly coding tasks and official letters.',
    seoKeywords:
      'Java Developer Internship in Satara, Java Internship Satara, Core Java Internship, OOP Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('Java developer', [
      {
        q: 'Is this a core Java internship in Satara?',
        a: 'Yes. You practise OOP, collections, exceptions and a simple Java REST demo with short weekly tasks you can screenshot and submit.'
      }
    ])
  },
  'python-developer': {
    headline: 'Python Developer Internship in Satara',
    seoTitle: 'Python Developer Internship in Satara | Growmore IT Services',
    seoDescription:
      'Python developer internship in Satara for scripts, APIs and automation. Paid Python internship with weekly tasks and official letters.',
    seoKeywords:
      'Python Developer Internship in Satara, Python Internship Satara, Python Scripting Internship, Automation Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('Python developer', [
      {
        q: 'What Python work will I do?',
        a: 'Weekly briefs cover Python scripts, JSON APIs, CSV clean-up and a short run-book — practical automation, not only theory.'
      }
    ])
  },
  'flutter-app-developer': {
    headline: 'Flutter App Developer Internship in Satara',
    seoTitle: 'Flutter Internship in Satara | App Developer | Growmore',
    seoDescription:
      'Flutter app developer internship in Satara for Dart, Android and iOS UI. Paid Flutter internship with weekly screens and official letters.',
    seoKeywords:
      'Flutter Internship in Satara, Flutter App Developer Internship Satara, Dart Internship Satara, Cross Platform App Internship, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('Flutter app developer', [
      {
        q: 'Is this a Flutter internship in Satara?',
        a: 'Yes. The Flutter internship covers widgets, navigation, lists, forms and API cards you can run on an Android phone each week.'
      }
    ])
  },
  'android-app-developer': {
    headline: 'Android App Developer Internship in Satara',
    seoTitle: 'Android App Developer Internship in Satara | Growmore',
    seoDescription:
      'Android app developer internship in Satara for Kotlin or Java screens, lists and local data. Paid Android internship with official letters.',
    seoKeywords:
      'Android App Developer Internship in Satara, Android Internship Satara, Kotlin Internship Satara, Mobile App Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('Android app developer', [
      {
        q: 'Do you offer an Android internship in Satara?',
        a: 'Yes. Native Android internship tasks cover login-to-home flow, lists, local save and a debug APK for review.'
      }
    ])
  },
  'ai-machine-learning': {
    headline: 'AI & Machine Learning Internship in Satara',
    seoTitle: 'AI & Machine Learning Internship in Satara | Growmore',
    seoDescription:
      'AI and machine learning internship in Satara for datasets, simple models and reports. Paid ML internship with official letters.',
    seoKeywords:
      'AI Internship in Satara, Machine Learning Internship Satara, ML Internship India, Data Science Internship Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('AI and machine learning', [
      {
        q: 'Is this an AI internship or only theory?',
        a: 'You clean a small dataset, train a simple model and write findings in plain language each week — guided, practical ML.'
      }
    ])
  },
  'ai-automation': {
    headline: 'AI Automation Internship in Satara',
    seoTitle: 'AI Automation Internship in Satara | Chatbot | Growmore',
    seoDescription:
      'AI automation internship in Satara for WhatsApp-style flows, SOP bots and workflow automation. Paid internship with official letters.',
    seoKeywords:
      'AI Automation Internship in Satara, Chatbot Internship Satara, Workflow Automation Intern, WhatsApp Automation Internship, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('AI automation', [
      {
        q: 'Will I work on WhatsApp or chatbot flows?',
        a: 'Yes. Weekly tasks include ready replies, a simple follow-up flow and an SOP another intern can run.'
      }
    ])
  },
  'ui-ux-designer': {
    headline: 'UI UX Designer Internship in Satara',
    seoTitle: 'UI UX Designer Internship in Satara | Figma | Growmore',
    seoDescription:
      'UI UX designer internship in Satara for Figma wireframes, hi-fi screens and handoff notes. Paid design internship with official letters.',
    seoKeywords:
      'UI UX Designer Internship in Satara, UI UX Internship Satara, Figma Internship Satara, Product Design Internship, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('UI UX designer', [
      {
        q: 'Is this a Figma internship in Satara?',
        a: 'Yes. The UI UX internship uses Figma for user flows, wireframes, hi-fi frames and developer handoff notes.'
      }
    ])
  },
  'graphic-designer': {
    headline: 'Graphic Designer Internship in Satara',
    seoTitle: 'Graphic Designer Internship in Satara | Growmore IT Services',
    seoDescription:
      'Graphic designer internship in Satara for social posts, banners and brand kits. Paid design internship with official letters.',
    seoKeywords:
      'Graphic Designer Internship in Satara, Graphic Design Internship Satara, Canva Internship Satara, Social Media Design Intern, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('graphic designer', [
      {
        q: 'What creatives will I make?',
        a: 'Weekly tasks include a social post set, banners, matching colours and web-safe exports for Instagram and campaigns.'
      }
    ])
  },
  'digital-marketing': {
    headline: 'Digital Marketing Internship in Satara',
    seoTitle: 'Digital Marketing Internship in Satara | SEO | Growmore',
    seoDescription:
      'Digital marketing internship in Satara for SEO, content calendars and campaign planning. Paid SEO internship with official letters.',
    seoKeywords:
      'Digital Marketing Internship in Satara, SEO Internship Satara, Social Media Marketing Intern Satara, Digital Marketing Intern Maharashtra, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('digital marketing', [
      {
        q: 'Is this an SEO internship in Satara?',
        a: 'Yes. The digital marketing internship covers keyword lists, on-page SEO checklists, a content calendar and a simple measurement sheet.'
      }
    ])
  },
  'cyber-security': {
    headline: 'Cyber Security Internship in Satara',
    seoTitle: 'Cyber Security Internship in Satara | Paid | Growmore IT Services',
    seoDescription:
      'Cyber security internship in Satara for website security checklists, OWASP awareness, VAPT basics and risk notes. Paid internship with official letters.',
    seoKeywords:
      'Cyber Security Internship in Satara, Cyber Security Intern Satara, Ethical Hacking Internship Satara, VAPT Internship Satara, Website Security Internship, Security Intern Satara, Paid Internship Satara, Growmore IT Services',
    faqs: faqs('cyber security', [
      {
        q: 'Is this a legal, defensive security internship?',
        a: 'Yes. Tasks stay defensive and legal: go-live checklists, password hygiene, OWASP-style notes and a short risk report. No illegal hacking.'
      }
    ])
  }
};

export const withInternshipSeo = (role) => {
  if (!role) return role;
  const extra = internshipSeo[role.slug] || {};
  return { ...role, ...extra };
};
